"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextHighlight = TextHighlight;

var _fuzzy = _interopRequireDefault(require("fuzzy"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * SPDX-FileCopyrightText: © 2023 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var optionsFuzzy = {
  post: '|+',
  pre: '+|'
};

function TextHighlight(_ref) {
  var children = _ref.children,
      match = _ref.match;

  var fuzzyMatch = _fuzzy.default.match(match, children, optionsFuzzy);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, match && fuzzyMatch ? fuzzyMatch.rendered.split('|').map(function (item, index) {
    var Text = item.includes('+') ? 'span' : 'strong';
    var value = item.replace(/\+/g, '');
    return value ? /*#__PURE__*/_react.default.createElement(Text, {
      key: index
    }, value) : null;
  }).filter(Boolean) : children);
}